import { PropsWithChildren } from 'react';

import PageSectionContainer from '../PageSectionContainer';

const createMarkup = (body?: any) => {
  return { __html: body };
};

const HTMLSection = ({ content }: PropsWithChildren<any>) => {
  return (
    <PageSectionContainer className="section__html">
      <div dangerouslySetInnerHTML={createMarkup(content.body)} />
    </PageSectionContainer>
  );
};

export default HTMLSection;
